import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    agudezaVisual: [],
  },

  getters: {
    getAgudezaVisual: (state) => state.agudezaVisual,
  },

  mutations: {
    SET_AGUDEZA_VISUAL(state, agudezaVisual) {
      state.agudezaVisual = agudezaVisual;
    },
  },

  actions: {
    async fetchAgudezaVisual({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catAgudezaVisual')
        .then((response) => {
          commit('SET_AGUDEZA_VISUAL', response.data.data);
        });
    },
  },
};
